// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"_buttons_primaryButton__Fr8fK"};